// extracted by mini-css-extract-plugin
module.exports = {"HomePage":"HomePage_HomePage__3Zwca"};